import {
    AfterViewChecked,
    Component,
    ElementRef,
    HostBinding,
    HostListener,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';

@Component({
    selector: 'app-fab',
    templateUrl: './fab.component.html',
    styleUrls: ['./fab.component.scss']
})
export class FabComponent implements OnInit, AfterViewChecked {
    @ViewChild('fab', {static: false}) fab: ElementRef;

    @Input() library: 'prime' | 'material' | 'fontawesome' = 'fontawesome';
    @Input() variant = 'fa-cog';
    @Input() text = '';
    @Input() items = []; // Array of menu items, including icon and label
    @Input() simple = false;

    @HostBinding('class.responsive') @Input() responsive = false;
    @HostBinding('class.inline') @Input() inline = false;
    @HostBinding('class.disabled') @Input() disabled = false;
    @HostBinding('class.floating') @Input() floating = true;

    @HostListener('click', ['$event.target'])
    onFABClick(event) {
    }

    constructor() {
    }

    ngAfterViewChecked() {
        const actions = document.querySelectorAll('.p-speeddial-action');
        actions.forEach((action: any, index) => {
            if (this.items[index]?.color) {
                action.style.backgroundColor = this.items[index].color;
            }
        });
    }

    ngOnInit(): void {
    }

    computeIcon() {
        switch (this.library) {
            case 'fontawesome':
                return `fa ${this.variant}`;
            case 'prime':
                return `pi ${this.variant}`;
            case 'material':
                return `${this.variant}`;
        }
    }
}
